import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import visibleCheckItem from 'webapp/modifiers/visible-check-item';
import DummyCellComponent from 'webapp/components/dummy-cell';
import GoalsProgressComponent from 'webapp/components/goals/progress';

import type Goal from 'webapp/models-custom/goal';

interface Args {
	model: Goal;
}

export default class MobileGoalRowComponent extends Component<Args> {
	@service('navigation') declare navigationService: Service.Navigation;

	@tracked isVisibleOnScreen = false;

	get goalData() {
		// will be always available bcos goal is saved
		return this.args.model.primaryDataModel!;
	}

	@action
	visibleChanged(isVisible: boolean): void {
		this.isVisibleOnScreen = isVisible;
	}
	<template>
		{{#if this.isVisibleOnScreen}}

			<tr class={{this.goalData.currentProgressClass}} data-id={{@model.id}}>
				<td class="cell source">
					<div class="source__info">
						<strong>{{@model.title}}</strong>
						<span>{{@model.timeframeText}}</span>
						{{!-- {{#if @model.showDataStatusIcon}}
                    <DataStatusIcon
                        @context="goal"
                        @lastSync={{@model.lastSync}}
                        @statusObjects={{@model.dataErrorStatusObjects}}
                        @skipActions={{true}}
                        @popupTheme={{this.navigationService.theme.id}}
                        @theme={{this.navigationService.theme.id}}
                    />
                {{/if}} --}}
					</div>
				</td>
				<td class="cell vis">
					<GoalsProgressComponent
						@model={{@model}}
						@goalData={{this.goalData}}
						@size="small"
					/>
				</td>
			</tr>

		{{else}}

			<tr {{visibleCheckItem this.visibleChanged}}>
				<DummyCellComponent />
			</tr>

		{{/if}}
	</template>
}
